import { Component, Input, OnInit } from '@angular/core';
import { BookingType, PriceInBookingType } from "@afidium/ts-facade";
import { PricesTableService } from "../../services/prices-table.service";

@Component({
    selector: 'tarifications-list',
    template: `
        <tarifications-header *ngFor="let price of priceArray;"
                              [price]="price"
                              [costOrRetail]="costOrRetail"
                              (onPriceSelect)="changeRateSelection($event)"
                              [booking]="booking"
                              [showReturnBtn]="true">
        </tarifications-header>
    `,
    styles: []
})
export class TarificationsListComponent implements OnInit {

    @Input()
    public priceArray: PriceInBookingType[];

    @Input()
    public costOrRetail: string;

    @Input()
    public booking: BookingType;

    public constructor(
        private readonly pricesTablesService: PricesTableService
    ) {
    }

    public ngOnInit(): void {
        this.priceArray = this.priceArray?.filter((price: PriceInBookingType): boolean => price[this.costOrRetail].type.toLowerCase() === "storedfare" && price[this.costOrRetail].xRank?.toLowerCase() !== "dummy");
    }

    public changeRateSelection(selectedRateId: string): void {
        this.pricesTablesService.setRateSelected(selectedRateId);
    }
}
